export const trafficCopMock = {
  original_prompt:
    "Find me some articles about the Americn revolution for 8th graders",
  response: "Would you like to refine by adding a standard?",
  data: {
    chips: [
      {
        label: "Articles",
        type: "content_types",
        value: "ARTICLE",
        score: 1,
        selected: true,
      },
      {
        label: "American Revolution",
        type: "topics",
        value: "clsm7w5t7000vcd90d63l7ryi",
        score: 1,
        selected: true,
      },
      {
        label: "8",
        type: "grade_levels",
        value: "8",
        score: 0.95,
        selected: true,
      },
      {
        label: "9",
        type: "grade_levels",
        value: "9",
        score: 0.95,
        selected: true,
      },
      {
        label:
          "7.5c.3: Students will examine the changes to the New York State Constitution and how they were made during the 19th century.",
        type: "standards",
        value: "ck0tzhgns1zbmi6p705975caf",
        score: 1.0,
        selected: true,
      },
    ],
    raw_llm_response: {
      article_type: {
        ARTICLE_INFORMATION: 0.9,
      },
      content_types: {
        ARTICLE: 1,
      },
      languages: null,
      topics: {
        "American Revolution": 1,
      },
      grade_levels: {
        "8": 0.95,
      },
      maturity_range: null,
      needle: "American Revolution",
    },
    search_query_params: {
      article_type: "ARTICLE_INFORMATION",
      concepts: [],
      content_types: ["ARTICLE"],
      grade_levels: [8],
      instructional_features: [],
      needle: "American Revolution",
      languages: [],
      maximum_maturity: null,
      minimum_maturity: null,
      reading_skills: [],
      streams: [],
      standards: ["ck0tzhgns1zbmi6p705975caf"],
      topics: ["clsm7w5t7000vcd90d63l7ryi"],
    },
    refinement_question: {
      question: "Would you like to add another topic to your search?",
      id: 4,
    },
  },
};
